import { create } from "zustand";
import type { TarotSpread } from "@/entities/spread/model/types";

type RecommendedSpreadState = {
  recommendedSpread: TarotSpread[] | null;
  status: "idle" | "loading" | "success" | "error";
  error: string | null;
  setRecommendedSpread: (spread: TarotSpread[]) => void;
  setStatus: (status: RecommendedSpreadState["status"]) => void;
  setError: (error: string | null) => void;
  clearRecommendedSpread: () => void;
};

const useRecommendedSpreadStore = create<RecommendedSpreadState>((set) => ({
  recommendedSpread: null,
  status: "idle",
  error: null,
  setRecommendedSpread: (spread) =>
    set({ recommendedSpread: spread, status: "success", error: null }),
  setStatus: (status) => set({ status }),
  setError: (error) => set({ error, status: "error" }),
  clearRecommendedSpread: () =>
    set({ recommendedSpread: null, status: "idle", error: null }),
}));

export default useRecommendedSpreadStore;

